const Health = () => <h2>Health OK</h2>;

Health.Layout = ({ children }) => children;

export default Health;
